// extracted by mini-css-extract-plugin
export default {"ghost_text":"GhostText_ghost_text__lH+uY"};